import * as React from 'react'
import PropTypes from 'prop-types'
import { DatePicker } from './date-picker'

const DatePickerBirthdate = React.forwardRef(function DatePickerBirthdate({ value, onChange, error, className }, ref) {
  return (
    <DatePicker
      ref={ref}
      value={value}
      onChange={onChange}
      error={error}
      className={className}
      fromYear={1950}
      toYear={new Date().getFullYear()}
    />
  )
})

DatePickerBirthdate.displayName = 'DatePickerBirthdate'

DatePickerBirthdate.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string
}

export { DatePickerBirthdate }
